import { useGetIncreasedIncome } from '@/query/queries/marketing/useGetIncreasedIncome';
import { LAYOUT_TYPE } from './constants';
import { IncreasedIncome } from './index';

export const useIncreasedIncome = ({
  layout = LAYOUT_TYPE.dashboard_desktop_card,
}) => {
  const { data } = useGetIncreasedIncome();

  if (!data) return null;

  return <IncreasedIncome data={data} layout={layout} />;
};
